(function () {
  const STORAGE_KEY = 'energea_compare_v1';
  const MAX = 3;

  function read() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX)));
  }

  function metaFromHandle(handle) {
    const el = document.getElementById('compare-meta-' + handle);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function syncCheckboxUI() {
    const selected = new Set(read().map((x) => x.handle));
    document.querySelectorAll('.js-compare-toggle').forEach((input) => {
      const h = input.getAttribute('data-compare');
      input.checked = selected.has(h);
    });
  }

  function renderBar() {
    const bar = document.getElementById('compare-bar');
    const thumbs = document.getElementById('compare-bar-thumbs');
    const btn = document.getElementById('compare-go');
    if (!bar || !thumbs || !btn) return;

    const items = read();
    bar.hidden = items.length === 0;
    thumbs.innerHTML = '';

    items.forEach((item) => {
      const div = document.createElement('div');
      div.className = 'compare-bar__item';
      div.innerHTML =
        '<img src="' +
        (item.featured_image || '') +
        '" alt="" width="48" height="48" loading="lazy"/>' +
        '<button type="button" class="compare-bar__remove" data-handle="' +
        item.handle +
        '" aria-label="Remove">&times;</button>';
      thumbs.appendChild(div);
    });

    const count = items.length;
    btn.setAttribute('aria-disabled', count < 2 ? 'true' : 'false');
    btn.classList.toggle('is-disabled', count < 2);
    btn.tabIndex = count < 2 ? -1 : 0;
  }

  function toggleHandle(handle, forceOn) {
    let items = read();
    const exists = items.some((x) => x.handle === handle);
    const meta = metaFromHandle(handle);
    if (!meta) return;

    if (forceOn === true || (!exists && !forceOn)) {
      if (!exists) {
        if (items.length >= MAX) return;
        items.push(meta);
      }
    } else {
      items = items.filter((x) => x.handle !== handle);
    }
    write(items);
    syncCheckboxUI();
    renderBar();
  }

  document.addEventListener('change', function (e) {
    const t = e.target;
    if (!t.classList || !t.classList.contains('js-compare-toggle')) return;
    const handle = t.getAttribute('data-compare');
    toggleHandle(handle, t.checked);
  });

  document.addEventListener('click', function (e) {
    const rm = e.target.closest('.compare-bar__remove');
    if (rm) {
      e.preventDefault();
      toggleHandle(rm.getAttribute('data-handle'), false);
      return;
    }
    const clear = e.target.closest('#compare-clear');
    if (clear) {
      write([]);
      syncCheckboxUI();
      renderBar();
      return;
    }
    const go = e.target.closest('#compare-go');
    if (go && go.classList.contains('is-disabled')) {
      e.preventDefault();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncCheckboxUI();
    renderBar();
    const go = document.getElementById('compare-go');
    if (go) {
      go.addEventListener('click', function (e) {
        if (go.classList.contains('is-disabled')) {
          e.preventDefault();
          return;
        }
        write(read());
      });
    }
  });
})();